import React, { useState, useRef } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { Alert } from "antd";

import { Spinner } from "../components/spinner/Spinner";
import { sendFiles } from "../app/files/api";

import "../styles/upload/upload.scss";

export const UploadOrders = () => {
  const [isSendSuccess, setIsSendSuccess] = useState(false);
  const [isSendError, setIsSendError] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);

  const [, setFile] = useState();
  const inputRef = useRef(null);

  const handleUploadClick = () => {
    // 👇 We redirect the click event onto the hidden input element
    inputRef.current?.click();
  };

  const handleFileChange = async (e) => {

    setIsSendError(false);
    setIsSendSuccess(false);

    if (!e.target.files) {
      return;
    }

    setFile(e.target.files[0]);
    setIsSending(true);
    
    await sendFiles(e.target.files[0])
      .then((data) => {
        if (data.status === 200) {
          setIsSendSuccess(true);
        } else {
          setIsSendError(true);
        }
      })
      .catch((e) => {
        setIsSendError(true);
        setErrorMsg(e.response.data.result.replace(/\n/g," "));
      });
    setIsSending(false);
  };

  return (
    <>
      <div className="uploader">
        <div className="uploader-header">
          <h2>Carga Masiva</h2>
        </div>
        <div className="uploader-messages">
          {isSendSuccess && (
            <Alert
              message="Carga Exitosa"
              description="El archivo se ha cargado correctamente."
              type="success"
              showIcon
            />
          )}
          {isSendError && (
            <Alert
              message="Carga Fallida"
              description={`${JSON.stringify(errorMsg)}`}
              type="error"
              showIcon
            />
          )}
        </div>

        <div className="uploader-dragger">
          {isSending && <Spinner tip="Cargando, por favor espere..." />}
          {!isSending && (
            <button onClick={handleUploadClick}>
             
                <div>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined color="#fff" />
                  </p>
                  <p className="ant-upload-text">
                    Haga click en esta área para cargar el archivo.
                  </p>
                  <p className="ant-upload-hint">
                    Estrictamente prohibido cargar datos de la empresa u otros
                    archivos prohibidos.
                  </p>
                </div>
            </button>
          )}
          <input
            type="file"
            ref={inputRef}
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </div>
      </div>
    </>
  );
};
